import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  cepMask,
  cnpjMask,
  cpfMask,
  phoneMask
} from "../../../../_metronic/_helpers/MasksHelper";

import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";
import { PAYMENT_PROVIDERS } from "../../../constants/ClientesDados";
import { Button, Tooltip } from "@material-ui/core";
import { Delete, PeopleAlt, Save } from "@material-ui/icons";
import { useImpersonate } from "../../../hooks/useImpersonate";
import { useLogoutAllDevices } from "../../../hooks/useLogoutAllDevices";
import * as S from "../../../components/Modal/Modal.styles";

export default function MeusDados(props) {
  const dispatch = useDispatch();
  const clientSubscription = useSelector(
    state => state.app.client_subscription
  );
  const states = useSelector(state => state.app.states);
  const cities = useSelector(state => state.app.cities);
  const professions = useSelector(state => state.app.professions);
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const person_types = useSelector(state => state.app.person_types);
  const subscriptionStatus = clientSubscription?.info?.status;
  const clientCanBeDeleted = subscriptionStatus === "canceled";
  const isButtonDisabled = !clientCanBeDeleted;
  const isDeleted = Boolean(props.formik.values.deleted_at);

  const {
    showModal: confirmLogout,
    openModal: onConfirmLogout,
    closeModal: onHideLogout,
    loading: logoutLoading,
    error: logoutError,
    handleLogout: handleLogoutAllDevices,
  } = useLogoutAllDevices(props.formik.values.user_id);

  const loadCidades = state => {
    dispatch({ type: "LOAD_CITIES", payload: { state: state } });
  };

  const { initialValues, setFieldValue, values } = props.formik;

  const documentMask = React.useCallback(
    value => {
      if (values.document_type?.id === "pf") {
        return cpfMask(value);
      } else {
        return cnpjMask(value);
      }
    },
    [values.document_type]
  );

  const isInitialized = React.useRef(false);

  React.useEffect(() => {
    if (isInitialized.current) return;

    if (
      !initialValues.phone &&
      !initialValues.postal_code &&
      !initialValues.document_number
    )
      return;

    if (initialValues.phone) {
      setFieldValue("phone", phoneMask(initialValues.phone));
    }

    if (initialValues.postal_code) {
      setFieldValue("postal_code", cepMask(initialValues.postal_code));
    }

    if (initialValues.document_number) {
      setFieldValue(
        "document_number",
        documentMask(initialValues.document_number)
      );
    }

    isInitialized.current = true;
  }, [documentMask]);

  const onConfirmDelete = () => {
    setConfirmDelete(true);
  };
  const onHide = () => {
    setConfirmDelete(false);
  };

  const { impersonate, isLoading } = useImpersonate();

  const handleImpersonateClick = () => {
    impersonate({ clientId: props.id });
  };

  return (
    <>
      {confirmDelete && (
        <ConfirmDeleteModal
          id={props.id}
          show={confirmDelete}
          onHide={onHide}
        />
      )}
      {confirmLogout && (
        <S.Modal>
          <S.ModalContent>
            <S.ModalTitle>Confirmação</S.ModalTitle>
            <S.Text>Tem certeza que deseja deslogar este usuário de todos os dispositivos?</S.Text>
            {logoutError && (
              <div style={{ color: 'red', marginTop: '10px', marginBottom: '10px' }}>
                {logoutError}
              </div>
            )}
            <S.ButtonRow>
              <S.ConfirmButton 
                onClick={handleLogoutAllDevices}
                disabled={logoutLoading}
              >
                {logoutLoading ? "Processando..." : "Confirmar"}
              </S.ConfirmButton>
              <S.CancelButton 
                onClick={onHideLogout}
                disabled={logoutLoading}
              >
                Cancelar
              </S.CancelButton>
            </S.ButtonRow>
          </S.ModalContent>
        </S.Modal>
      )}
      {props.formik.values.deleted_at && (
        <>
          <div className="row mb-5">
            <div className="col-md-6">
              <label className="form-label">Deletado por</label>
              <input
                type="text"
                name="deleted_by"
                className="form-control"
                value={props.formik.values.deleted_by || ""}
                disabled
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Deletado em</label>
              <input
                type="text"
                name="deleted_at"
                className="form-control"
                value={props.formik.values.deleted_at || ""}
                disabled
              />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-md-12">
              <label className="form-label">Motivo da desativação</label>
              <textarea
                name="deleted_reason"
                className="form-control"
                value={props.formik.values.deleted_reason || ""}
                readOnly
                disabled
              />
            </div>
          </div>
        </>
      )}
      <div className="row mb-5">
        <div className="col-md-6">
          <label className="form-label">Criado por</label>
          <input
            type="text"
            name="created_by"
            className="form-control"
            value={props.formik.values.created_by || "Não conhecido"}
            disabled
          />
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-xl-4">
          <label className="form-label">
            Profissão <span className="text-danger">&nbsp;*</span>
          </label>
          <Select
            name="profession"
            isSearchable={true}
            isClearable={true}
            options={professions}
            className={
              props.formik.errors.profession && props.formik.touched.profession
                ? "is-invalid"
                : ""
            }
            onChange={value => {
              props.formik.setFieldValue("profession", value);
            }}
            value={props.formik.values.profession}
            placeholder="Selecione.."
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            noOptionsMessage={() => <span>Sem resultados.</span>}
            theme={customSelectStyle}
            isDisabled={!!isDeleted}
          />
          {props.formik.errors.profession &&
            props.formik.touched.profession && (
              <label className="invalid-feedback">
                {props.formik.errors.profession}
              </label>
            )}
        </div>
        {props.formik.values.profession != null &&
          props.formik.values.profession.name === "Advogado" && (
            <>
              {" "}
              <div className="col-xl-4">
                <label className="form-label">Nº da OAB </label>
                <input
                  type="number"
                  name="oab"
                  className={
                    "form-control " +
                    (props.formik.errors.oab && props.formik.touched.oab
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.oab}
                  onChange={props.formik.handleChange}
                  disabled={isDeleted}
                />
                {props.formik.errors.oab && props.formik.touched.oab && (
                  <label className="invalid-feedback">
                    {props.formik.errors.oab}
                  </label>
                )}
              </div>
              <div className="col-xl-4">
                <label className="form-label">Estado OAB</label>
                <Select
                  name="oab_state"
                  isSearchable={true}
                  isClearable={true}
                  options={states}
                  className={
                    props.formik.errors.oab_state &&
                    props.formik.touched.oab_state
                      ? "is-invalid"
                      : ""
                  }
                  onChange={value => {
                    props.formik.setFieldValue("oab_state", value);
                  }}
                  value={props.formik.values.oab_state}
                  placeholder="Selecione.."
                  getOptionLabel={option => option.state}
                  getOptionValue={option => option.state}
                  noOptionsMessage={() => <span>Sem resultados.</span>}
                  theme={customSelectStyle}
                  isDisabled={!!isDeleted}
                />
                {props.formik.errors.oab_state &&
                  props.formik.touched.oab_state && (
                    <label className="invalid-feedback">
                      {props.formik.errors.oab_state}
                    </label>
                  )}
              </div>
            </>
          )}
      </div>

      <div className="row mb-5">
        <div className="col-xl-6">
          <label className="form-label">
            Nome completo <span className="text-danger">&nbsp;*</span>
          </label>
          <input
            type="text"
            name="name"
            className={
              "form-control " +
              (props.formik.errors.name && props.formik.touched.name
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.name}
            onChange={props.formik.handleChange}
            disabled={isDeleted}
          />
          {props.formik.errors.name && props.formik.touched.name && (
            <label className="invalid-feedback">
              {props.formik.errors.name}
            </label>
          )}
        </div>
        <div className="col-xl-3">
          <div className="form-group">
            <label className="form-label">
              Tipo <span className="text-danger">&nbsp;*</span>
            </label>
            <Select
              name="document_type"
              isSearchable={false}
              options={person_types}
              className={
                props.formik.errors.document_type &&
                props.formik.touched.document_type
                  ? "is-invalid"
                  : ""
              }
              onChange={value => {
                props.formik.setFieldValue("document_type", value);
                props.formik.setFieldValue("document_number", "");
              }}
              value={props.formik.values.document_type}
              placeholder="Selecione.."
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              noOptionsMessage={() => <span>Sem resultados.</span>}
              theme={customSelectStyle}
              isDisabled={!!isDeleted}
            />
            {props.formik.errors.document_type &&
              props.formik.touched.document_type && (
                <label className="invalid-feedback">
                  {props.formik.errors.document_type}
                </label>
              )}
          </div>
        </div>

        <div className="col-xl-3">
          <label className="form-label">
            {props.formik.values.document_type?.id === "pf" ? "CPF" : "CNPJ"}{" "}
            <span className="text-danger">&nbsp;*</span>
          </label>
          <input
            type="text"
            name="document_number"
            className={
              "form-control " +
              (props.formik.errors.document_number &&
              props.formik.touched.document_number
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.document_number}
            onChange={evt =>
              props.formik.setFieldValue(
                "document_number",
                documentMask(evt.target.value)
              )
            }
            disabled={isDeleted}
          />
          {props.formik.errors.document_number &&
            props.formik.touched.document_number && (
              <label className="invalid-feedback">
                {props.formik.errors.document_number}
              </label>
            )}
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-xl-6">
          <label className="form-label">
            Segmento <span className="text-danger">&nbsp;*</span>
          </label>
          <Form.Check
            type="radio"
            label="B2C"
            name="client_type"
            id="client_type_b2c"
            checked={props.formik.values.client_type === "b2c"}
            onClick={() => {
              if (isDeleted) return;
              props.formik.setFieldValue("client_type", "b2c");
            }}
            disabled={isDeleted}
          />
          <Form.Check
            type="radio"
            label="B2B"
            name="client_type"
            id="client_type_b2b"
            checked={props.formik.values.client_type === "b2b"}
            onClick={() => {
              if (isDeleted) return;
              props.formik.setFieldValue("client_type", "b2b");
            }}
            disabled={isDeleted}
          />
          {props.formik.errors.client_type &&
            props.formik.touched.client_type && (
              <label className="invalid-feedback d-block">
                {props.formik.errors.client_type}
              </label>
            )}
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-xl-6">
          <label className="form-label">
            E-mail <span className="text-danger">&nbsp;*</span>
          </label>
          <input
            type="text"
            name="email"
            className={
              "form-control " +
              (props.formik.errors.email && props.formik.touched.email
                ? "is-invalid"
                : "")
            }
            onChange={props.formik.handleChange}
            value={props.formik.values.email}
            disabled={isDeleted}
          />
        </div>
        <div className="col-xl-6">
          <label className="form-label">
            Telefone <span className="text-danger">&nbsp;*</span>
          </label>
          <input
            type="text"
            name="phone"
            className={
              "form-control " +
              (props.formik.errors.phone && props.formik.touched.phone
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.phone}
            onChange={evt =>
              props.formik.setFieldValue("phone", phoneMask(evt.target.value))
            }
            disabled={isDeleted}
          />
          {props.formik.errors.phone && props.formik.touched.phone && (
            <label className="invalid-feedback">
              {props.formik.errors.phone}
            </label>
          )}
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-xl-4">
          <label className="form-label">CEP</label>{" "}
          <span className="text-danger">&nbsp;*</span>
          <input
            type="text"
            name="postal_code"
            className={
              "form-control " +
              (props.formik.errors.postal_code &&
              props.formik.touched.postal_code
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.postal_code}
            onChange={evt =>
              props.formik.setFieldValue(
                "postal_code",
                cepMask(evt.target.value)
              )
            }
            disabled={isDeleted}
            maxLength={9}
          />
          {props.formik.errors.postal_code &&
            props.formik.touched.postal_code && (
              <label className="invalid-feedback">
                {props.formik.errors.postal_code}
              </label>
            )}
        </div>
        <div className="col-xl-4">
          <label className="form-label">Estado </label>{" "}
          <span className="text-danger">&nbsp;*</span>
          <Select
            name="state"
            isSearchable={true}
            isClearable={true}
            options={states}
            className={
              props.formik.errors.state && props.formik.touched.state
                ? "is-invalid"
                : ""
            }
            onChange={value => {
              props.formik.setFieldValue("state", value);

              if (value) {
                loadCidades(value.state);
              } else {
                props.formik.setFieldValue("city", null);
                loadCidades("");
              }
            }}
            value={props.formik.values.state}
            placeholder="Selecione.."
            getOptionLabel={option => option.name}
            getOptionValue={option => option.state}
            noOptionsMessage={() => <span>Sem resultados.</span>}
            theme={customSelectStyle}
            isDisabled={!!isDeleted}
          />
        </div>
        <div className="col-xl-4">
          <label className="form-label">Cidade </label>{" "}
          <span className="text-danger">&nbsp;*</span>
          <Select
            name="city"
            isSearchable={true}
            isClearable={true}
            options={cities}
            className={
              props.formik.errors.city && props.formik.touched.city
                ? "is-invalid"
                : ""
            }
            onChange={value => props.formik.setFieldValue("city", value)}
            value={props.formik.values.city}
            placeholder="Selecione.."
            getOptionLabel={option => option.name}
            getOptionValue={option => option.id}
            noOptionsMessage={() => <span>Sem resultados.</span>}
            theme={customSelectStyle}
            isDisabled={!!isDeleted}
          />
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-xl-6">
          <label className="form-label">Endereço</label>{" "}
          <span className="text-danger">&nbsp;*</span>
          <input
            type="text"
            name="address"
            className={
              "form-control " +
              (props.formik.errors.address && props.formik.touched.address
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.address}
            onChange={props.formik.handleChange}
            disabled={isDeleted}
          />
          {props.formik.errors.address && props.formik.touched.address && (
            <label className="invalid-feedback">
              {props.formik.errors.address}
            </label>
          )}
        </div>
        <div className="col-xl-6">
          <label className="form-label">Bairro</label>{" "}
          <span className="text-danger">&nbsp;*</span>
          <input
            type="text"
            name="district"
            className={
              "form-control " +
              (props.formik.errors.district && props.formik.touched.district
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.district}
            onChange={props.formik.handleChange}
            disabled={isDeleted}
          />
          {props.formik.errors.district && props.formik.touched.district && (
            <label className="invalid-feedback">
              {props.formik.errors.district}
            </label>
          )}
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-xl-6">
          <label className="form-label">Número</label>{" "}
          <span className="text-danger">&nbsp;*</span>
          <input
            type="text"
            name="address_number"
            className={
              "form-control " +
              (props.formik.errors.address_number &&
              props.formik.touched.address_number
                ? "is-invalid"
                : "")
            }
            value={props.formik.values.address_number}
            onChange={props.formik.handleChange}
            disabled={isDeleted}
          />
          {props.formik.errors.address_number &&
            props.formik.touched.address_number && (
              <label className="invalid-feedback">
                {props.formik.errors.address_number}
              </label>
            )}
        </div>
        <div className="col-xl-6">
          <label className="form-label">Complemento</label>
          <input
            type="text"
            name="address_complement"
            className="form-control"
            value={props.formik.values.address_complement}
            onChange={props.formik.handleChange}
            disabled={isDeleted}
          />
          {props.formik.errors.address_complement &&
            props.formik.touched.address_complement && (
              <label className="invalid-feedback">
                {props.formik.errors.address_complement}
              </label>
            )}
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-xl-6">
          <label className="form-label">Provedor de Pagamento</label>
          <input
            type="text"
            className="form-control"
            value={
              PAYMENT_PROVIDERS[clientSubscription?.info?.provider] || "..."
            }
            disabled
          />
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-xl-12">
          <label className="form-label">Observações</label>
          <textarea
            name="comments"
            rows="5"
            className="form-control"
            onChange={props.formik.handleChange}
            value={props.formik.values.comments}
            disabled={isDeleted}
          ></textarea>
        </div>
      </div>

      <div className="row">
        {!props.formik.values.deleted_at && (
          <div className="col-12 d-flex justify-content-center">
            <Button
              variant="contained"
              color="primary"
              className="mx-2"
              onClick={props.formik.handleSubmit}
            >
              <Save />
              SALVAR
            </Button>

            <Button
              variant="contained"
              color="secondary"
              className="mx-2"
              disabled={isLoading}
              onClick={handleImpersonateClick}
            >
              <PeopleAlt className="mr-2" />
              LOGAR COMO USUÁRIO
            </Button>

            <Button
              variant="contained"
              color="secondary"
              className="mx-2"
              onClick={onConfirmLogout}
            >
              DESLOGAR DE TODOS DISPOSITIVOS
            </Button>

            {isButtonDisabled ? (
              <>
                <Tooltip title="Para deletar o usuário a assinatura deve estar cancelada.">
                  <span className="mx-2">
                    <Button
                      variant="contained"
                      color="danger"
                      size="large"
                      onClick={onConfirmDelete}
                      disabled={isButtonDisabled}
                    >
                      <Delete />
                      DELETAR
                    </Button>
                  </span>
                </Tooltip>
              </>
            ) : (
              <Button
                variant="contained"
                className="mx-2"
                onClick={onConfirmDelete}
              >
                <Delete />
                DELETAR
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
}
